<template>
  <footer>
    <img src="img/footer.png" alt="푸터">

    <div id="top" @click="scrollToTop">
      <img src="img/btn_top.png" alt="탑버튼">
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
    data () {
      return {

      }
    },
    methods: {
      scrollToTop () {
        TweenMax.to(window, 1, { scrollTo: 0 })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue